export function processApiResponse(response: any): { errorCode: string | null; data: any } {
	if (response.errors && response.errors.length > 0) {
		// Return the classification of the first error as errorCode
		return {
			errorCode: response.errors[0].extensions.classification,
			data: null,
		};
	} else if (response.data) {
		// Return the data if no errors are present
		return {
			errorCode: null,
			data: response.data,
		};
	}
	// Return null values if neither errors nor data are present
	return {
		errorCode: null,
		data: null,
	};
}
